import { DescriptedLabel } from 'iebt-zing-storybook'
import React, { useState } from 'react'
import { IEvaluation, IField, IStep } from '../constants'
import { BuildField } from './field'
import { SectionArea } from './sectionArea'
import { AddButton, LightButton } from '../../FormWrapper/style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { v4 as uuidv4 } from 'uuid'
import { trans } from 'sharedKernel/i18n'

export function EvaluationArea(evaluation: IEvaluation, evaluationKey: number, disabled: boolean = false): JSX.Element {
  let countSteps = 1
  const [evaluationState, setEvaluationState] = useState<IEvaluation>(evaluation)

  const addStep = (): void => {
    const newStep: IStep = {
      id: `${String(uuidv4())}_idScreen`,
      name: '',
      namePlaceholder: '',
      path: '',
      isDeleted: false,
      sections: []
    }
    evaluationState.steps.push(newStep)
    setEvaluationState({ ...evaluationState })
    evaluation.steps = evaluationState.steps
  }

  const removeStep = (stepKey: number): void => {
    evaluationState.steps[stepKey].isDeleted = true
    setEvaluationState({ ...evaluationState })
    evaluation.steps = evaluationState.steps
  }

  const activeSteps = evaluationState.steps.filter(step => !step.isDeleted)

  return (
    <div key={evaluationKey}>
      {evaluationState.steps.map((step, stepKey) => {
        if (step.isDeleted) {
          return true
        }

        const isFirstStep = stepKey === 0
        const canDelete = activeSteps.length > 1

        return (
          <div style={{ margin: '0px 0px 10px 30px' }} key={stepKey}>
            <div className="d-flex align-items-center gap-2 mb-2">
              <DescriptedLabel boldText={true}>{`Rodada de Avaliação #${countSteps++}`}</DescriptedLabel>
              {canDelete && !disabled && (
                <LightButton
                  className="text-primary"
                  onClick={() => {
                    removeStep(stepKey)
                  }}
                  data-cy={`evaluationStep${stepKey + 1}DeleteButton`}
                >
                  <FontAwesomeIcon icon={['fas', 'trash']} />
                </LightButton>
              )}
            </div>
            <div style={{ margin: '0px 0px 0px 10px' }}>
              <div className="mb-4">
                {BuildField(
                  {
                    id: step.id,
                    type: 'text',
                    value: step.name,
                    namePlaceholder: step.namePlaceholder,
                    label: 'Nome da Etapa',
                    isRequired: true,
                    description: 'Campo Obrigatório',
                    maxLength: 140,
                    isDeleted: false,
                    path: `evaluation.steps[${stepKey}]`,
                    validations: [
                      {
                        type: 'required',
                        stage: 'launch'
                      },
                      {
                        type: 'maxLength',
                        param: 140,
                        stage: 'save'
                      },
                      {
                        type: 'letterRequired',
                        stage: 'all'
                      }
                    ],
                    updateFieldState: (field: IField) => {
                      evaluationState.steps[stepKey].name = field.value
                      setEvaluationState({ ...evaluationState })
                    },
                    dataCy: `evaluationStep${stepKey + 1}NameInput`,
                    disabled: disabled
                  },
                  step.id
                )}
              </div>
            </div>
            <div>
              <SectionArea
                initialState={step}
                stateKey={stepKey}
                sectionIdentifier={`evaluation.steps[${stepKey}]`}
                updateState={(item) => {
                  evaluationState.steps[stepKey].sections = item.sections
                  setEvaluationState({ ...evaluationState })
                }}
                availableQuestionTypes={[
                  {
                    label: 'Pontuação',
                    value: 'score'
                  }
                ]}
                defaultQuestionType="score"
                disabled={disabled}
              />
            </div>
          </div>
        )
      })}
      {!disabled && (
        <div style={{ margin: '20px 0px 0px 30px' }}>
          <AddButton
            onClick={addStep}
            data-cy="evaluationAddStepButton"
          >
            {trans('Adicionar Etapa')}
          </AddButton>
        </div>
      )}
    </div>
  )
}
